import { render, staticRenderFns } from "./ServerUsageChart.vue?vue&type=template&id=cf20166c&scoped=true&"
import script from "./ServerUsageChart.vue?vue&type=script&lang=js&"
export * from "./ServerUsageChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf20166c",
  null
  
)

export default component.exports